import * as React from 'react'
import type { SVGProps } from 'react'

interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgCusmanFullLogo = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 175 28"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="#28C76F"
      d="M139.634 2.994v1.108a14 14 0 0 0-9.973-.968c-3.33.92-6.177 3.037-7.963 5.922a12.97 12.97 0 0 0-1.657 9.619c.722 3.294 2.704 6.199 5.544 8.125.235-.249.478-.472.728-.691 2.026-1.8 4.46-2.846 7.084-2.846 2.761 0 5.318 1.163 7.407 3.142.136.127.256.248.399.395a13.36 13.36 0 0 0 4.293-4.744 12.96 12.96 0 0 0 1.546-6.14V2.99zm-6.235 18.987a6.37 6.37 0 0 1-3.467-1.023 6.1 6.1 0 0 1-2.298-2.724 5.9 5.9 0 0 1-.355-3.508 6 6 0 0 1 1.708-3.108 6.3 6.3 0 0 1 3.195-1.66 6.4 6.4 0 0 1 3.605.347 6.2 6.2 0 0 1 2.798 2.237 5.95 5.95 0 0 1 1.049 3.374 5.98 5.98 0 0 1-1.827 4.288 6.32 6.32 0 0 1-4.408 1.777"
    />
    <path
      fill="#030426"
      d="M.001 14.974c0-8.1 6.527-12.38 13.104-12.38 4.343 0 8.174 1.933 10.598 5.89l-5.31 3.36c-1.175-1.573-2.925-2.805-5.288-2.805-3.17 0-5.875 2.299-5.875 5.942 0 3.729 2.695 6.03 5.875 6.03 2.363 0 4.113-1.242 5.298-2.808l5.295 3.36c-2.411 3.865-6.243 5.886-10.598 5.886-6.572 0-13.099-4.283-13.099-12.475M51.23 26.989H43.9v-3.04c-1.373 2.026-3.794 3.5-7.286 3.5-4.968 0-9.178-2.983-9.178-10.315V3.054h7.334v12.842c0 2.983 1.56 5.2 4.598 5.2 2.978 0 4.541-2.21 4.541-5.2V3.053h7.331zM54.962 20.636l5.819-1.52c.378 1.152 1.23 2.762 3.548 2.762 1.326 0 2.554-.643 2.554-1.988 0-.783-.472-1.521-2.081-2.026l-3.321-1.198c-4.07-1.426-5.82-4.001-5.82-6.991 0-4.474 4.113-7.092 8.941-7.092 4.634 0 7.993 2.53 8.843 6.398l-5.724 1.38c-.613-1.84-1.842-2.255-2.835-2.255-1.42 0-2.13.828-2.13 1.658 0 .783.472 1.519 2.13 2.026l3.065 1.108c2.646.875 6.149 2.67 6.149 6.992 0 4.834-4.213 7.548-9.707 7.548-4.938.01-8.675-2.246-9.431-6.802M93.275 13.455c0-3.037-1.703-4.51-3.926-4.51-2.317 0-4.161 1.473-4.161 4.51V26.99h-7.34V3.053h7.332V6c1.331-1.989 3.602-3.405 6.864-3.405 2.884 0 5.39 1.198 6.953 3.775 1.515-2.165 4.166-3.775 8.034-3.775 5.208 0 8.981 3.23 8.981 10.585v13.81h-7.316V13.455c0-3.037-1.704-4.51-3.926-4.51-2.365 0-4.164 1.473-4.164 4.51V26.99h-7.331zM150.774 3.053h7.344v3.038c1.36-2.026 3.773-3.497 7.273-3.497 4.966 0 9.178 2.982 9.178 10.315v14.085h-7.334V14.146c0-2.982-1.561-5.202-4.598-5.202-2.981 0-4.542 2.21-4.542 5.202V26.99h-7.33z"
    />
  </svg>
)
export default SvgCusmanFullLogo
